import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@core/base.component';
import { Logger } from '@core/logger';

enum DisplayMode {
	LAWYER_ONLY = 'lawyer-only',
	CLERK_ONLY = 'clerk-only',
	BOTH = 'both',
}

interface CannotAddLawyerToMatterDialogData {
	leapLawyerName?: string;
	leapClerkName?: string;
}

interface VM {
	leapLawyerName: string | null;
	leapClerkName: string | null;
	displayMode: DisplayMode;
}

const DefaultVMValues: VM = {
	leapLawyerName: null,
	leapClerkName: null,
	displayMode: DisplayMode.BOTH,
};

@Component({
	selector: 'app-cannot-add-lawyer-clerk-to-matter',
	templateUrl: './cannot-add-lawyer-clerk-to-matter.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CannotAddLawyerClerkToMatterComponent
	extends BaseComponent<VM>
	implements OnInit
{
	public DisplayMode = DisplayMode;

	constructor(
		public dialogRef: MatDialogRef<CannotAddLawyerClerkToMatterComponent>,
		@Inject(MAT_DIALOG_DATA) public data: CannotAddLawyerToMatterDialogData,
	) {
		super(structuredClone(DefaultVMValues));
	}

	ngOnInit(): void {
		const leapLawyerName = this.data?.leapLawyerName ?? null;
		const leapClerkName = this.data?.leapClerkName ?? null;
		let displayMode = DisplayMode.BOTH;

		if (leapLawyerName && !leapClerkName) {
			displayMode = DisplayMode.LAWYER_ONLY;
		} else if (!leapLawyerName && leapClerkName) {
			displayMode = DisplayMode.CLERK_ONLY;
		} else if (!leapLawyerName && !leapClerkName) {
			Logger.error(
				'[CannotAddLawyerToMatterComponent] Both leapLawyerName and leapClerkName are null, at least one of them should be provided',
			);
		}

		this.VM = {
			leapLawyerName,
			leapClerkName,
			displayMode,
		};
	}

	closeDialog() {
		this.dialogRef.close();
	}
}
